module.exports = __webpack_public_path__ + "media/more_info/cert-550ce22e.png";